/**
 * Cover Background Slideshow Controller
 * Handles automatic rotation of multiple background images in the Byron theme cover block
 */

$(document).ready(function() {
    const slideshowContainer = document.getElementById('background-slideshow');
    
    if (!slideshowContainer) {
        return; // No slideshow needed
    }
    
    const images = slideshowContainer.querySelectorAll('.slideshow-image');
    const totalImages = images.length;
    
    if (totalImages <= 1) {
        return; // Not enough images for a slideshow
    }
    
    let currentImageIndex = 0;
    const transitionDuration = 5000; // 5 seconds per image
    const fadeDuration = 1000; // 1 second fade transition
    
    // Set up CSS for smooth transitions
    images.forEach((image, index) => {
        image.style.opacity = index === 0 ? '1' : '0';
        image.style.transition = `opacity ${fadeDuration}ms ease-in-out`;
    });
    
    function showNextImage() {
        const currentImage = images[currentImageIndex];
        const nextIndex = (currentImageIndex + 1) % totalImages;
        const nextImage = images[nextIndex];
        
        // Fade out current image
        currentImage.style.opacity = '0';
        currentImage.classList.remove('active');
        
        // Fade in next image
        nextImage.style.opacity = '1';
        nextImage.classList.add('active');
        
        currentImageIndex = nextIndex;
    }
    
    // Start the slideshow rotation
    setInterval(showNextImage, transitionDuration);
});